"use client"
import { useState, useEffect } from "react"

interface LazyYouTubeProps {
  videoId: string
  customerName?: string
  title?: string
}
function LazyYouTube({
  videoId,
  customerName,
  title = "Customer's testimonial",
}: LazyYouTubeProps) {
  const [showIframe, setShowIframe] = useState(false)
  const [origin, setOrigin] = useState("")

  useEffect(() => {
    if (typeof window !== "undefined") {
      setOrigin(window.location.origin)
    }
  }, [])
  const buildSrc = (isTestimonial: boolean) => {
    const base = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1&playsinline=1&rel=0&modestbranding=1&`

    const variant = isTestimonial
      ? "&controls=0&cc_load_policy=3"
      : "&controls=1&fs=1&iv_load_policy=3&color=white"

    const originPart = origin ? `&origin=${origin}` : ""

    return base + variant + originPart
  }
  const src = buildSrc(Boolean(customerName))
  if (!showIframe) {
    return (
      <div
        onClick={() => setShowIframe(true)}
        className="relative w-full pb-[56.25%] bg-center bg-cover cursor-pointer md:h-[380px] rounded"
        style={{
          backgroundImage: `url('https://img.youtube.com/vi/${videoId}/maxresdefault.jpg')`,
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="100"
            height="100"
            viewBox="0 0 48 48"
          >
            <path
              fill="#FF3D00"
              d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"
            ></path>
            <path fill="#FFF" d="M20 31L20 17 32 24z"></path>
          </svg>
        </div>
      </div>
    )
  }

  return (
    <iframe
      src={src}
      className="w-full aspect-video rounded"
      title={customerName ? `${customerName} testimonial` : title}
      allowFullScreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen;"
      key={videoId}
    />
  )
}

export default LazyYouTube
